
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minu/seaded/teavitused",
      function () {
        return require("private-next-pages/minu/seaded/teavitused/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minu/seaded/teavitused"])
      });
    }
  